export enum KeySuffixOptions {
  Auto = "auto",
  Biometric = "biometric",
  Pin = "pin",
}
